import { ServerTags } from '../types/Server/ServerTags';

export const serverTagDisplayOrder: ServerTags[] = [ServerTags.Partnered];
